<template>
<div class="column is-12">
            <!----------- sidebar ---------------------------------->
            <div class="field">
              <div class="control">
                <label class="label">{{ elLabel }} <a href="http://miaolz123.github.io/vue-markdown/" target="_blank" class="icon"><i class="fa fa-question-circle-o"></i></a> </label>
                <textarea 
                class="textarea" 
                placeholder="Zusatzinfo im Sidebar" 
                rows="4" 
                :value="data"
                @input="$emit('wasUpdated', $event.target.value)"
                ></textarea>
              </div>
            </div>
</div>
</template>

<script>
export default {
  // inject: ['$validator'],
  props: ['data', 'elLabel'],
  data () {
    return {
    }
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Markdown.vue